export default __webpack_public_path__ + "static/media/404.601bfe31.svg";